import { EntityType } from "../shared/enums/EntityType";

export const ROUTE_TO_ENTITY_MAP: Record<string, EntityType> = {
  "/assessments": EntityType.ASSESSMENT,
  "/subjects": EntityType.SUBJECT,
  "/teacher-subjects": EntityType.TEACHER_SUBJECT,
  "/timeslots": EntityType.TIMESLOT,
  "/curriculum-requirements": EntityType.CURRICULUM_REQUIREMENT,
  "/timetables": EntityType.TIMETABLE,
  "/reports": EntityType.REPORT_CARD,
  "/terms": EntityType.TERM,
  "/vote-heads": EntityType.VOTE_HEAD,
  "/invoices": EntityType.INVOICE,
  "/suppliers": EntityType.SUPPLIER,
  "/inventory": EntityType.INVENTORY_ITEM,
  "/inventory-logs": EntityType.INVENTORY_LOG,
  "/stock": EntityType.STOCK_LEVEL,
  "/students": EntityType.STUDENT,
  "/enrollments": EntityType.ENROLLMENT,
  "/teachers": EntityType.TEACHER,
  "/users": EntityType.USER,
  "/parents": EntityType.PARENT_GUARDIAN,
  "/branches": EntityType.BRANCH,
  "/classrooms": EntityType.CLASSROOM,
  "/fee-structures": EntityType.FEE_STRUCTURE,
  "/academic-years": EntityType.ACADEMIC_YEAR,
  "/grade-levels": EntityType.GRADE_LEVEL,
  "/attendance-records": EntityType.ATTENDANCE_RECORD,
  "/announcements": EntityType.ANNOUNCEMENT,
  "/notifications": EntityType.NOTIFICATION,
  "/timetable-slots": EntityType.TIMETABLE_SLOT,
  "/sms-templates": EntityType.SMS_TEMPLATE,
  "/sms-outbox": EntityType.SMS_OUTBOX,
  "/students-term-reports": EntityType.STUDENT_TERM_REPORT,
  "/fee-allocations": EntityType.STUDENT_FEE_ALLOCATION,
  "/student-fee-ledgers": EntityType.STUDENT_FEE_LEDGER,
  "/purchase-orders": EntityType.PURCHASE_ORDER,
  "/newsletters": EntityType.NEWSLETTER,
  "/transition-records": EntityType.TRANSITION_RECORD,
  "/bank-transactions-staging": EntityType.BANK_TRANSACTION_STAGING,
  "/audit-logs": EntityType.AUDIT_LOG,
  "/payments": EntityType.PAYMENT,
};

// Reverse the mapping: Entity -> Route
export const ENTITY_TO_ROUTE_MAP = Object.entries(ROUTE_TO_ENTITY_MAP).reduce(
  (acc: Record<string, string>, [route, entity]) => {
    acc[entity] = route;
    return acc;
  },
  {},
);
